import { Helmet } from 'react-helmet';
import PageHeader from '../Common/PageHeader';
import BlogItem from './BlogItem';
import './BlogPage.css';
import { useState } from 'react';
import { Pagination } from "react-bootstrap";

const BlogPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  return (
    <>
      <Helmet>
        <title>Tips and Tricks on How to Use Everyday Products </title>
        <meta
          name="keywords"
          content="new unique items,creative items for home,creative home decor items,creative decorative items,creative products to sell online,creative memories items for sale,creative gift supplies,creative item for home and office,unique products for home,unique home products,unique office wall decor,interesting home products,unique decorative pieces,unique home essentials,funky home decor items,unique home decorative items,unique home office decor,unique household gadgets"
        />
        <meta
          name="description"
          content="Have no idea where to start decorating your house? Get tips on how to use unique home products from Bakumia to use in your house and make every corner stand out."
        />
      </Helmet>
      <PageHeader title="Blog" />
      <section className="mx-auto px-4 my-5">
        <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
          <BlogItem currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages} />
        </div>

      {totalPages > 1 && (
          <div className="d-flex justify-content-center my-4">
            <Pagination className="custom-pagination">
              {/* Previous Button */}
              <Pagination.Prev
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              />

              {/* Page Indicator */}
              <Pagination.Item active>
                Page {currentPage} of {totalPages}
              </Pagination.Item>

              {/* Next Button */}
              <Pagination.Next
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
      )}

        <style>
          {`
  .custom-pagination .page-item.active .page-link {
    background-color: #791989;
    border-color: #791989;
    color: #fff;
  }

  .custom-pagination .page-link {
    color: #791989;
    border-radius: 8px;
    padding: 6px 12px;
  }

  .custom-pagination .page-link:hover {
    background-color: #f3e6f9;
    color: #791989;
  }

  .custom-pagination .page-item.disabled .page-link {
    color: #aaa;
    background-color: #f8f9fa;
  }
`}
        </style>

      </section>
    </>
  );
};

export default BlogPage;
